export default {
	APP_IFRAME_START_LOADING: {
		eventId: 642,
		src: 42,
		params: {
			widget_id: 'widgetId',
			widget_name: 'widgetName',
			instance_id: 'compId',
			appId: 'appDefinitionId',
			loading_time: 'loadingTime',
			pid: 'pageId',
			pn: 'pageNo',
			iss: 'ssr',
			tts: 'totalLoadingTime',
			external_app_id: 'externalAppDefinitionId',
			external_widget_id: 'externalWidgetId',
			lazy_load: 'lazyLoad',
		},
	},
}
